import { render, staticRenderFns } from "./btn-follow-lifestyle.mpx?vue&type=template&id=7d906274&isComponent&outputPath=components%2Fbtn-follow-lifestyled6144cdc%2Findex"
import script from "./btn-follow-lifestyle.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-follow-lifestyled6144cdc%2Findex"
export * from "./btn-follow-lifestyle.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-follow-lifestyled6144cdc%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports